import React from 'react';
import Loader from '@sunbit-dev/ui/src/components/ui/loader/Loader';
import { selectIsLoading } from '../selectors';
import { useSelector } from 'react-redux';
import loaderImage from '@sunbit-dev/ui/src/components/ui/loader/assets/darkLoader.gif';

const LoaderContainer: React.FC = () => {
  const isLoading = useSelector(selectIsLoading);
  return <Loader loader={loaderImage} active={isLoading} />;
};

export default LoaderContainer;
